import { FC } from 'react';
import { getDataFromQueryVar } from '@/features/Core/utils/urlHelpers';
import { useDecodedParams } from '@/features/Core/hooks/useDecodedParams';
import { generateQueryTitle } from '@/features/Projects/utils/queryTitleUtils';
import SkeletonBar from '@/features/Core/components/SkeletonBar/SkeletonBar';

const QueryBreadcrumbLabel: FC = () => {
  const decodedParams = useDecodedParams();
  const queryType = getDataFromQueryVar("t", decodedParams);
  const nodeOneLabel = (queryType === "p" || queryType === "l")
    ? getDataFromQueryVar("lone", decodedParams)
    : getDataFromQueryVar("l", decodedParams) || '';
  const nodeTwoLabel = queryType === "p" ? getDataFromQueryVar("ltwo", decodedParams) : '';
  let constraint = null;
  if (queryType === "p") {
    constraint = getDataFromQueryVar("c", decodedParams);
  } else if (queryType === "l") {
    constraint = getDataFromQueryVar("cat", decodedParams);
  }

  const queryTitle = generateQueryTitle(queryType, nodeOneLabel || '', nodeTwoLabel || '', constraint);

  if (queryTitle) return <>{queryTitle}</>;
  return <SkeletonBar width="150px" height="17px" />;
};

export default QueryBreadcrumbLabel;
